module.exports = __webpack_public_path__ + "static/fonts/Mont-HeavyItalic.17c1d13.woff2";